import styled from 'styled-components';

var CheckMark = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1rrft2r-0"
})([""]);

export default CheckMark;
//# sourceMappingURL=CheckMark.js.map
